





























































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { Attribute } from '@empathybroker/tsclient-search';

import { Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import { DataTable, Tabs, UiTextbox } from '../../components';

import { ApiEnum, DomainEnum } from '../../enums';

import { capitalizeSentence } from '../../filters/capitalize-sentence.filter';

import { GUARDS_EXECUTOR, SetAttributeWithUrlGuard } from '../../guards';

import { GuardResolveFunction } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { CONFIG_CONSTS } from '../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../store/context/context.consts';
import { SEARCH_CONSTS } from '../../store/search/search.consts';

import { StringUtils } from '../../utils';

export default {
  name: 'browse-configurations-attributes',
  props: {
    loading: Object
  },
  beforeRouteEnter: GUARDS_EXECUTOR([
    SetAttributeWithUrlGuard.execute
  ]),
  beforeRouteUpdate: GUARDS_EXECUTOR([
    SetAttributeWithUrlGuard.execute
  ]),
  components: {
    Tabs,
    UiTextbox,
    DataTable
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(SEARCH_CONSTS.moduleName, {
      attributes: SEARCH_CONSTS.getters.attributes
    }),
    attributeNamesTabs: function (): any[] {
      return this.instanceConfig.tools[ActionTypeEnum.CONFIGURATION].attributeNames.map((attributeName: string) => {
        const attributeNameMessage = this.getAttributeNameMessage(attributeName);
        return {
          id: attributeName,
          text: (!!attributeNameMessage ? capitalizeSentence(attributeNameMessage) : attributeName)
        };
      });
    },
    attributeName: function (): string {
      return this.$route.params[ROUTER_CONSTS.params.attribute.name];
    },
    data: function (): any[] {
      const attributeValues = this.attributes[this.attributeName];
      let data = (!!attributeValues && (attributeValues.items || attributeValues.children) || []);
      if (!!this.query) {
        data = data.filter(attribute => this.attributeMatchesQuery(attribute, this.query));
      }
      return data;
    },
    selectedAttribute: function () {
      const attributeValue = this.$route.params[ROUTER_CONSTS.params.attribute.value];
      return SetAttributeWithUrlGuard.findAttributeById(attributeValue, this.data);
    },
    attributeNameMessage: function (): string {
      return this.getAttributeNameMessage(this.attributeName);
    },
    backViewMessage: function (): string {
      return ((this.$route.name === ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list) ? this.attributeNameMessage
        : this.messages.configurations);
    }
  },
  data: function () {
    return {
      columns: [
        {
          id: 'name'
        }, {
          id: 'id',
          width: '25%'
        }
      ],
      expandedChildrenIds: [],
      query: undefined,
      contextWatchDisabled: false,
      messages: this.$epb.messages.tools.configurations
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setQuery: CONTEXT_CONSTS.actions.setQuery
    }),
    ...mapActions(SEARCH_CONSTS.moduleName, {
      loadAttributes: SEARCH_CONSTS.actions.loadAttributes
    }),
    loadData: async function (): Promise<void> {
      this.$emit('updateLoading', { visible: true });
      try {
        await this.loadAttributes({
          attribute: this.attributeName
        });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.SEARCH));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    },
    getAttributeNameMessage: function (attributeName: string) { // TODO temporary fix, attributeMessages needs prettyName
      const attributeNameMessageOptions = {
        'category': () => this.messages.attributes.names.category,
        'promos_ids': () => this.messages.attributes.names.promosIds,
        'groups_ids': () => this.messages.attributes.names.groupsIds
      };
      return (attributeNameMessageOptions[attributeName]() || attributeName);
    },
    updateAttributeName: async function (attributeName: string): Promise<void> {
      this.query = undefined;
      this.contextWatchDisabled = true;
      await this.setQuery(undefined);
      this.contextWatchDisabled = false;
      this.$router.replace({
        ...this.$route,
        params: {
          ...this.$route.params,
          [ROUTER_CONSTS.params.attribute.name]: attributeName
        },
        query: {
          ...this.$route.query,
          [ROUTER_CONSTS.query.query]: undefined
        }
      });
    },
    onAttributeClick: function (attribute): void {
      this.$router.push({
        ...this.$route,
        name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list,
        params: {
          ...this.$route.params,
          [ROUTER_CONSTS.params.attribute.value]: attribute.specificId
        }
      });
    },
    onBackClick: function (): void {
      const route = (this.$route.name === ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list) ? {
        ...this.$route,
        name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].attribute,
        params: {
          ...this.$route.params,
          [ROUTER_CONSTS.params.attribute.value]: undefined
        }
      } : {
        ...this.$route,
        name: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].list
      };
      this.$router.push(route);
    },
    onQueryChange: async function (): Promise<void> {
      const inputEl: HTMLInputElement = (this.$refs.searchbox.$refs.input as HTMLInputElement);
      await this.setQuery(inputEl.value || undefined);
      this.$emit('contextChanged');
      this.$refs.dataTable.resetScroll();
    },
    attributeMatchesQuery: function (attribute: Attribute, query: string): boolean {
      return !!this.getMatchingParentIds([attribute], query);
    },
    getMatchingParentIds: function (attributes: Attribute[], query: string, parentIds: string[] = []) {
      let match = false;
      const normalizedQuery = StringUtils.normalize(query);
      attributes.forEach((attribute: Attribute) => {
        const normalizedName = StringUtils.normalize(attribute.name);
        if (normalizedName.includes(normalizedQuery) || attribute.id.toLowerCase().includes(normalizedQuery)) {
          match = true;
        } else if (!!attribute.children) {
          parentIds.push(attribute.specificId);
          const childrenMatch = !!this.getMatchingParentIds(attribute.children, query, parentIds);
          if (!childrenMatch) {
            parentIds.pop();
          } else {
            match = true;
          }
        }
      });
      return (match ? parentIds : undefined);
    }
  },
  beforeRouteLeave: async function (to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    if (!!this.context.query) {
      this.contextWatchDisabled = true;
      await this.setQuery(undefined);
      this.$emit('contextChanged');
      next({
        name: to.name,
        params: to.params,
        query: {
          ...to.query,
          [ROUTER_CONSTS.query.query]: undefined
        }
      });
    } else {
      next();
    }
  },
  watch: {
    context: {
      handler: function (): void {
        if (!this.contextWatchDisabled) {
          this.query = this.context.query;
        }
      },
      deep: true,
      immediate: true
    },
    data: {
      handler: function (): void {
        if (!!this.query) {
          this.expandedChildrenIds = (this.getMatchingParentIds(this.data, this.query) || []);
        } else {
          this.expandedChildrenIds = [];
        }
      },
      immediate: true
    },
    attributeName: {
      handler: function (): void {
        if (!this.attributes[this.attributeName]) {
          this.loadData();
        }
      },
      immediate: true
    }
  }
};

